import { Idea } from '@models/Sessions/Idea/Idea';
import { Participant } from '@models/Sessions/Participant';
import { UserRelation } from '@models/Sessions/UserRelation';

export function filter(idea: Idea, term: string) {
  if (term.length) {
    const match = key => key.toLowerCase().indexOf(term.toLowerCase()) !== -1;
    if (idea.title && match(idea.title)) {
      return true;
    }
    if (idea.one_liner && match(idea.one_liner)) {
      return true;
    }

    return false;
  }

  return true;
}

export function filterToRate(
  idea: Idea,
  participants: any,
  user: UserRelation,
  isEnabled: boolean,
) {
  if (isEnabled) {
    const P = participants[idea.created_by];
    if (
      P &&
      user.votes_for.indexOf(P.team) >= 0 &&
      idea.created_by !== user._id &&
      !idea.voting.my.x &&
      !idea.voting.my.y
    ) {
      return true;
    }

    return false;
  }

  return true;
}

export function matchPossibleCollaborators(
  participant: Participant,
  idea: Idea,
) {
  const collaborators = idea.collaborators.map(collaborator => {
    return collaborator.participant_id;
  });

  return (
    participant._id !== idea.created_by &&
    collaborators.indexOf(participant._id) === -1
  );
}
